/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const useBultosPalet = (id_tipo_caja) => {
  const token = localStorage.getItem("@Token");
  const [butlosPalet, setBultosPalet] = useState([]);
  const [isButosPaletsLoading, setIsBultosPaletLoading] = useState(false);

  const getBultosPalet = async () => {
    setIsBultosPaletLoading(true);
    try {
      const response = await api.get(
        `api/etiquetas/bultos_palet/?id_tipo_caja=${id_tipo_caja}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      setBultosPalet(response.data);
    } catch (error) {
      setBultosPalet([]);
      console.log(error);
    } finally {
      setIsBultosPaletLoading(false);
    }
  };

  useEffect(() => {
    if (id_tipo_caja !== 0 && id_tipo_caja !== "" && id_tipo_caja !== "0") {
      getBultosPalet();
    } else {
      setBultosPalet([]);
    }
  }, [id_tipo_caja]);

  return { butlosPalet, isButosPaletsLoading };
};
